import { useState } from 'react';
import '../styles/FaqSection.css';

const FAQS = [
  {
    id: 'what-is-doppler',
    question: 'What is Doppler?',
    answer:
      'Doppler is rebuilding capital markets for the tokenized era. Our stack combines regulated custody, fully audited reserves, and strictly vetted strategies designed for safety, transparency, and scale. We are focused on helping institutions and users access productive on-chain opportunities through infrastructure built for real-world standards.',
  },
  {
    id: 'deposit-withdraw',
    question: 'When can I deposit to or withdraw from Doppler Vault?',
    answer:
      'Deposits are open 24/7 and start earning instantly. Withdrawals can be requested anytime but execute after a 7–8 day withdrawal period.',
  },
  {
    id: 'withdrawal-period',
    question: 'Why is there a withdrawal period?',
    answer:
      'The withdrawal period is set to facilitate funds settlement and ensure efficient operations to minimize slippage, optimize yields, and maintain Vault stability.',
  },
  {
    id: 'risks',
    question: 'What are the risks of Doppler Vaults?',
    answer:
      'No protocol can be considered entirely risk-free, but Doppler minimizes third-party risks—such as custody and trading-firm exposures—by relying exclusively on top-tier solutions and employing measures like rigorous due diligence.',
  },
];

export default function FaqSection({ zIndex }) {
  const [openId, setOpenId] = useState(null);

  function toggle(id) {
    setOpenId((current) => (current === id ? null : id));
  }

  return (
    <section className="faq" style={{ zIndex }}>
      <div className="faq__topbar">
        <span className="faq__brand">Doppler.finance</span>
        <span className="faq__pill">
          <span className="faq__pill-brace">{'{'}</span>
          FAQ
          <span className="faq__pill-brace">{'}'}</span>
        </span>
      </div>

      <h2 className="faq__heading">
        <span className="faq__line">
          <span className="faq__muted">Your</span> <span className="faq__bold">Questions</span>
        </span>
        <span className="faq__line">
          <span className="faq__muted">and Our</span> <span className="faq__bold">Answers</span>
        </span>
      </h2>

      <div className="faq__list">
        {FAQS.map((item) => {
          const isOpen = openId === item.id;
          return (
            <div key={item.id} className={`faq-item ${isOpen ? 'faq-item--open' : ''}`}>
              <button
                type="button"
                className="faq-item__question"
                onClick={() => toggle(item.id)}
                aria-expanded={isOpen}
              >
                <span>{item.question}</span>
                <svg
                  className="faq-item__chevron"
                  viewBox="0 0 24 24"
                  fill="none"
                  aria-hidden="true"
                >
                  <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
              <div className="faq-item__answer-wrap">
                <p className="faq-item__answer">{item.answer}</p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}